var activities = [
  "Follow up Call Mr. Anoop Shah for quote confirmation",
  "Email TechWiz all catologs and brochures for Tube Cleaners",
  "Visit XYZ Company for presentation of developed ideas with working prototypes",
  "Call Back Rajesh if mail is not received by 5 PM",
];
var notes = [
  "This is just a sample note, actual notes data to be fetched from database",
  "One another set of notes, even this should be fetched from API",
];
var others = [
  "Any other data can be displayed in this tab.",
  "Delete this tab is not required",
  "Test number 3",
];

module.exports = {
  activities,
  notes,
  others,
};
